export default "/images/calendaricon.svg?0f028f634485023902de77360cb18e25";